import ga from '../utils/ga'

export const reportViewSurveyBanner = (surveyName: string) => {
  ga('send', 'event', 'Survey', 'View', surveyName, { nonInteraction: true })
}

export const reportStartSurveyClick = (surveyName: string) => {
  ga('send', 'event', 'Survey', 'click', surveyName)
}
